import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "benefits",
  class: "container mx-auto py-24 sm:py-32"
}
const _hoisted_2 = { class: "grid lg:grid-cols-2 place-items-center lg:gap-24" }
const _hoisted_3 = { class: "grid lg:grid-cols-2 gap-4 w-full" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = { class: "text-5xl text-muted-foreground/15 font-medium transition-all delay-75 group-hover/number:text-muted-foreground/30" }

import { Card, CardContent, CardHeader, CardTitle } from "@/components/landingPage/ui/card";

import {
  Sparkle,
  Tag,
  Paintbrush,
  Blocks,
  LineChart,
  Wallet,
} from "lucide-vue-next";

interface BenefitsProps {
  icon: string;
  title: string;
  description: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Benefits',
  setup(__props) {

const benefitList: BenefitsProps[] = [
  {
    icon: "sparkle",
    title: "Connaissance de soi",
    description:
      "Découvrez vos forces, valeurs et besoins à travers des activités ludiques et bienveillantes adaptées à votre rythme.",
  },
  {
    icon: "lineChart",
    title: "Insertion professionnelle",
    description:
      "Construisez votre projet professionnel avec des recommandations personnalisées de métiers, formations et entreprises inclusives.",
  },
  {
    icon: "blocks",
    title: "Accompagnement expert",
    description:
      "Bénéficiez du soutien d'une équipe pluridisciplinaire : psychologues TSA, conseillers en insertion et éducateurs spécialisés.",
  },
  {
    icon: "wallet",
    title: "Sensibilisation entreprises",
    description:
      "Créez des ponts entre talents neurodivergents et entreprises sensibilisées à l'inclusion et à la neurodiversité.",
  },
];

const iconMap: Record<
  string,
  | typeof Sparkle
  | typeof Tag
  | typeof Paintbrush
  | typeof Blocks
  | typeof LineChart
  | typeof Wallet
> = {
  sparkle: Sparkle,
  tag: Tag,
  paintbrush: Paintbrush,
  blocks: Blocks,
  lineChart: LineChart,
  wallet: Wallet,
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", null, [
        _createElementVNode("h2", { class: "text-lg text-[#ff9500] mb-2 tracking-wider" }, "Notre Mission"),
        _createElementVNode("h2", { class: "text-3xl md:text-4xl font-bold mb-4" }, " Inclusion - Orientation - Découverte "),
        _createElementVNode("p", { class: "text-xl text-muted-foreground mb-8" }, " Autrement Capable est une plateforme digitale inclusive qui valorise les forces cognitives et émotionnelles des personnes neurodivergentes pour construire un avenir professionnel choisi et réduire la désinsertion. ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(benefitList, ({ icon, title, description }, index) => {
          return _createVNode(_unref(Card), {
            key: title,
            class: "bg-muted/50 dark:bg-card hover:bg-background dark:hover:bg-background transition-all delay-75 group/number"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(CardHeader), null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(iconMap[icon]), { class: "size-8 mb-6 text-[#ff9500]" })),
                    _createElementVNode("span", _hoisted_5, "0" + _toDisplayString(index + 1), 1)
                  ]),
                  _createVNode(_unref(CardTitle), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(title), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(CardContent), { class: "text-muted-foreground" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(description), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        }), 64))
      ])
    ])
  ]))
}
}

})